/**
 * @generated SignedSource<<3ed649f28f441a76c594bdc67a34b342>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DetachProjectFileFromTaskInput = {
  fileId: string;
  taskId: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type detachProjectFileFromTaskMutation$variables = {
  input: DetachProjectFileFromTaskInput;
};
export type detachProjectFileFromTaskMutation$data = {
  readonly detachProjectFileFromTask: {
    readonly deletedFileId: string | null;
    readonly task: {
      readonly fileCount: number | null;
    } | null;
    readonly error: string | null;
  } | null;
};
export type detachProjectFileFromTaskMutation = {
  variables: detachProjectFileFromTaskMutation$variables;
  response: detachProjectFileFromTaskMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedFileId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fileCount",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "error",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "detachProjectFileFromTaskMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DetachProjectFileFromTaskPayload",
        "kind": "LinkedField",
        "name": "detachProjectFileFromTask",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Task",
            "kind": "LinkedField",
            "name": "task",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "detachProjectFileFromTaskMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DetachProjectFileFromTaskPayload",
        "kind": "LinkedField",
        "name": "detachProjectFileFromTask",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Task",
            "kind": "LinkedField",
            "name": "task",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "40a744c70b9dc07cdb298a44ee4c4c3b",
    "id": null,
    "metadata": {},
    "name": "detachProjectFileFromTaskMutation",
    "operationKind": "mutation",
    "text": "mutation detachProjectFileFromTaskMutation(\n  $input: DetachProjectFileFromTaskInput!\n) {\n  detachProjectFileFromTask(input: $input) {\n    deletedFileId\n    task {\n      fileCount\n      id\n    }\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "c2638eb3f778fd2202968407738379f8";

export default node;
